'use client';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  typographyVariants,
} from '@v2/ui';
import React, { useEffect } from 'react';

type Props = {
  event: LeagueEvent;
};

import { LeagueEvent } from '@interfaces/APITravel';
import { v2Links } from '@utils/navigation/links';
import { format, isPast } from 'date-fns';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { AlertDialogDescription } from '@radix-ui/react-alert-dialog';
export function EventEndedDialog({ event }: Props) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const router = useRouter();

  useEffect(() => {
    if (isPast(new Date(event.occurs_at_local))) setIsModalOpen(true);
  }, [event.occurs_at_local]);

  return (
    <AlertDialog open={isModalOpen} onOpenChange={setIsModalOpen}>
      <AlertDialogContent className="flex flex-col items-center justify-center gap-8 px-4">
        <Image
          src="/icons/event-ended-icon.svg"
          alt="event ended icon"
          width={80}
          height={80}
        />
        <AlertDialogHeader className="text-center">
          <AlertDialogTitle>Leave page?</AlertDialogTitle>
        </AlertDialogHeader>

        <AlertDialogDescription className="text-center">
          The event you selected has ended on&nbsp;
          {format(new Date(event.occurs_at_local), 'LLL dd, y')}. Please select
          another one.
        </AlertDialogDescription>

        <AlertDialogFooter className="w-full justify-stretch">
          <AlertDialogCancel
            className="w-full"
            onClick={() => {
              router.push(v2Links.home);
              setIsModalOpen(false);
            }}
          >
            Go back
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
